<div class="container">
  <section class="pd-tb subscription">
   
         <div class="headingdiv">
          <h4 class="heading-5">Ease your talent acquisition <a class="orangeText" href="javascript:void(0)" routerLink="/dashboard"> Skip for now</a> </h4>
        </div>
          <ul  class="nav nav-pills sub">
              <li class="active">
                  <a href="javascript:void(0)" routerLink="/subscription"> Subscription plans</a>
              </li>
              <li hidden><a href="javascript:void(0)" routerLink="/inventory"> Inventory purchase</a>
              </li>
          </ul>
         <p class="para">Buy a plan that works best for you </p>


         <div class="row plan" *ngIf="!freePlan" >
          <!-- First Card -->
           <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12" *ngFor="let plan of allPlans; let i=index;">
            <div class="card-grid-2 hover-up"  (click)="highlight(plan)" [ngClass]="getRowClass(plan)">
              <!--  selected -->
              <div class="pill"><span> {{plan.planName}} </span></div>
          
           
      
            <div class="card-block-info">
              <h6 class="orangetext">${{plan.planAmount}} 
                <span>/ {{plan.validity < 2 ? (plan.validity + (" "+plan.validityType)) :  (plan.validity + (" "+plan.validityType +'s'))}}
              
              </span></h6>
            
              <div class="mt-3" *ngIf="plan.concurrentJobsAssignedEachPlan">
              <p>{{plan.concurrentJobsAssignedEachPlan}}</p>
            
              </div>
              <ul class="planlist checkmark">
                <li><span>{{plan.numberOfJob}}</span> Job posting for <span>{{plan.validity < 2 ? (plan.validity + (" "+plan.validityType)) : (plan.validity + (" "+plan.validityType+'s'))}}</span>
                </li>
                <li><span>{{plan.numberOfView}}</span> Resume views</li>
                <!-- <li><span>{{plan.numberOfClicks || 0}}</span> Number of Clicks</li> -->
              </ul>
    
              <div class="choose">
                 <a href="javascript:void(0);" class="planbtn" [routerLink]="'/address/'+plan.id">Choose plan</a>
                 <a href="javascript:void(0);" class="planbtn fill"  [routerLink]="'/address/'+plan.id">Selected</a>
              </div>
            </div>
          </div> <!--Main card div  -->
           </div> <!--End First card div  -->
           
         </div>
         <div class="row plan" *ngIf="freePlan">
          <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 center" >
            <div class="card-grid-2 hover-up"   [ngClass]="getRowClass(freePlan)">
              <!--  selected -->
              <div class="pill"><span> {{freePlan.planName}} </span></div>
          
           
      
            <div class="card-block-info">
              <h6 class="orangetext">Free Plan
                <span>
              
              </span></h6>
            
              <div class="mt-3" *ngIf="freePlan.concurrentJobsAssignedEachPlan">
              <p>{{freePlan.concurrentJobsAssignedEachPlan}}</p>
            
              </div>
              <ul class="planlist checkmark">
                <li><span>{{freePlan.numberOfJob}}</span> Job posting  <span>
                  
                  <!-- {{freePlan.validity < 2 ? freePlan.validity + " month" :  freePlan.validity + " months"}} -->

                </span></li>
                <li><span>{{freePlan.numberOfView}}</span> Resume views</li>
                <li><span>{{freePlan.numberOfClicks  || 0}}</span> Number of Clicks</li>
              </ul>
    
              <div class="choose">
                 <a href="javascript:void(0);" class="planbtn" (click)="freePlanactive(freePlan?.id)">Continue</a>
                 <!-- <a href="javascript:void(0);" class="planbtn fill"  [routerLink]="'/address/'+freePlan.id">Selected</a> -->
              </div>
            </div>
          </div> <!--Main card div  -->
           </div>
         </div>
     
  </section>
</div>
  <!-- End -->
  <div class="planfooter" hidden>
    <div class="container">
    <div class="flexcss">
     
      <div class="d-flex">
       <img src="../../../../assets/images/cart.svg" class="wt">
       <div class="price">
         <p class="selectedplan">Selected : {{allInventoryPlans?.planName}} Plan {{allInventoryPlans?.validity}}</p>
         <p class="money">${{allInventoryPlans?.planAmount}} (excluding taxes)</p>
       </div>
      </div>
      
         <div class="choose">
           <a href="javascript:void(0);" class="planbtn fill" routerLink="/checkout">Continue</a>
       </div>
    </div>
   </div>
  
  </div>